import { defineComponent} from 'vue';
import sys from '@truckdown/jsclient';

export default defineComponent({
    setup: function (props) {

        return {
            
        }
    }
});

